<template>
  <div class="sales-report__section sales-section__nav" v-if="displayedSections.length > 0">
    <div id="summary-title" class="sales-report-body__header-section"><div class="sales-report-body__section-title">Report Navigation</div></div>
    <affix class="sales-nav vue-affix affix-top" relative-element-selector="#sales-report__affix-anchor" :offset="{ top: -36, bottom: 0 }">
      <div class="sales-nav__container">
        <template v-for="section in displayedSections">
          <a v-if="section == 'Locations'" class="sales-nav__item" :class="`sales-nav__item--${section.replace(' ', '')}`" :href="`#a_${section}`">{{ section }}<span class="sales-nav__pill">{{ contents.locations.length }}</span></a>
          <a v-else-if="section == 'Practices'" class="sales-nav__item" :class="`sales-nav__item--${section.replace(' ', '')}`" :href="`#a_${section}`">{{ section }}<span class="sales-nav__pill">{{ contents.businesses.length }}</span></a>
          <a v-else class="sales-nav__item" :class="`sales-nav__item--${section.replace(' ', '')}`" :href="`#a_${section.replace(' ', '')}`">{{ section }}</a>
        </template>
        <div v-if="loadingSections" class="sales-nav__item h-center-align"><MoonLoader size="25px" color="#ffffff"></MoonLoader></div>
      </div>
    </affix>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { Affix } from 'vue-affix';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';

  export default {
    name: 'ReportNavigation',
    components: {
      Affix,
      MoonLoader,
    },
    computed: {
      ...mapGetters('purchaseActivity', [
        'contents',
        'displayedSections',
        'loadingSections',
      ]),
    }
  };
</script>
